export function filterProducts(products, shippingProfileId) {
  return products.filter((product) => {
    const childrenSelected =
      product.variants &&
      product.variants.length &&
      product.variants.every(
        (variant) =>
          variant.shippingProfile &&
          !(
            shippingProfileId &&
            variant.shippingProfile &&
            shippingProfileId == variant.shippingProfile.id
          )
      );
    return (
      (!childrenSelected && !product.shippingProfile) ||
      (shippingProfileId &&
        product.shippingProfile &&
        shippingProfileId == product.shippingProfile.id)
    );
  });
}

export function formatVariants(variants, shippingProfileId) {
  return filterProducts(variants, shippingProfileId).map((variant) => {
    return {
      value: variant.id,
      text: variant.selectedValues.reduce(
        (acc, value) => (!acc ? `${value.name}` : `${acc} ${value.name}`),
        ""
      )
    };
  });
}
